interface DiscountCategory {
	categoryId: number;
	discountPercentage: number;
}

export const poraPoraConfigurators: DiscountCategory[] = [
	{ categoryId: 342, discountPercentage: 15 },
	{ categoryId: 348, discountPercentage: 15 },
	{ categoryId: 352, discountPercentage: 15 },
	{ categoryId: 1065, discountPercentage: 15 },
	{ categoryId: 344, discountPercentage: 15 },
	{ categoryId: 347, discountPercentage: 15 },
	{ categoryId: 349, discountPercentage: 15 },
	{ categoryId: 412, discountPercentage: 15 },
	{ categoryId: 413, discountPercentage: 15 },
	{ categoryId: 414, discountPercentage: 15 },
	{ categoryId: 415, discountPercentage: 15 },
	{ categoryId: 416, discountPercentage: 15 },
	{ categoryId: 472, discountPercentage: 15 },
	{ categoryId: 719, discountPercentage: 15 },
	{ categoryId: 377, discountPercentage: 15 },
	{ categoryId: 401, discountPercentage: 15 },
	{ categoryId: 1495, discountPercentage: 15 },
	{ categoryId: 554, discountPercentage: 15 },
	{ categoryId: 565, discountPercentage: 20 },
	{ categoryId: 2295, discountPercentage: 20 },
	{ categoryId: 861, discountPercentage: 50 },
	{ categoryId: 864, discountPercentage: 50 },
	{ categoryId: 865, discountPercentage: 50 },
	{ categoryId: 2487, discountPercentage: 50 },
	{ categoryId: 2485, discountPercentage: 50 },
	{ categoryId: 1566, discountPercentage: 50 },
	{ categoryId: 1567, discountPercentage: 50 },
	{ categoryId: 1568, discountPercentage: 50 },
	{ categoryId: 577, discountPercentage: 15 },
	{ categoryId: 1374, discountPercentage: 15 },
	{ categoryId: 2038, discountPercentage: 20 },
];
